export const EmptyState = ({ icon: Icon, title, description, action }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center" data-testid="empty-state">
      {Icon && (
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-md bg-stone-100 mb-4">
          <Icon className="h-8 w-8 text-stone-400" strokeWidth={1.5} />
        </div>
      )}
      <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{title}</h3>
      <p className="text-sm text-stone-600 max-w-sm mb-4">{description}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};